export const settings = {
    header: "Settings",
    items: {
        motion: {
            label: "Reduced Motion",
        },
        contrast: {
            label: "High Contrast Mode",
        },
    },
};
